import { Reducer } from 'redux';
import { ResetStore } from 'types/App';
import {
  ServiceGroupsGetExperience,
  IExperienceServiceGroupsState,
  initialExperienceServiceGroupsState,
  TServiceGroupsGetExperienceAction,
} from 'experience/types/ExperienceServiceGroups';

export const experienceServiceGroupsReducer: Reducer<
  IExperienceServiceGroupsState,
  TServiceGroupsGetExperienceAction
> = (state = initialExperienceServiceGroupsState, action) => {
  switch (action.type) {
    case ResetStore.RESET: {
      return initialExperienceServiceGroupsState;
    }

    case ServiceGroupsGetExperience.REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ServiceGroupsGetExperience.SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };

    case ServiceGroupsGetExperience.FAILED: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};
